import vetting_modal from './vetting_modal.js'
import pages from './pages.js'
import firebase from './firebase.js'

export default {
  app_name: 'Suitup Office',
  operation_name: 'Office',
  display_app_name: 'Suitup',
  stylesheet: '/office.css',
  favicon: '/office_favicon.png',
  base_api_url: 'https://office.suitupapi.club/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'piola',
  preview_link: 'https://office.suitup.website/offer_preview/',
  company_panel_url: 'https://office.companies.suitup.co.il/',
  seo_single_position_path: 'single_office_position',
  field: 'האדמיניסטרציה',
  recruitement_field: 'השמה בעולם האדמיניסטרציה',
  discrete_emoji: '🤩',
  icon: '⭐',
  files: {
    is_profile_default_checked: false
  },
  applicant_modal: {
    languages: ['אנגלית']
  },
  applicant_history_company_modal: {
    job_title_options: []
  },
  vetting_modal,
  pages,
  images: {
    logo_bright: '/suitup_logo_bright.png',
    logo_dark: '/suitup_logo_dark.png'
  },
  links: {
    website_url: 'https://www.suitup.co.il/',
    web_base_url: 'https://office.suitup.website/',
    app_store_url: 'https://apps.apple.com/us/app/suitup-office/id1458626807',
    google_play_url: 'https://play.google.com/store/apps/details?id=website.suitup.office'
  },
  hashtags: 'suitup',
  firebase,
  full_env_name: 'suitup_office_production'
}
